import styles from './iconList.module.scss';

export default function IconListItem(props) {
  const { icon, title, description } = props;
  return (
    <div className={styles.iconListItem}>
      <div className={styles.iconListItemIcon}>
        <img src={icon} alt={title} />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}
